import { cn } from '@/lib/utils';

export default function RevisionBadge({ className }: { className?: string }) {
  return (
    <span className={cn('notification-revision-badge', className)}>
      REVISED
    </span>
  );
}
